import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What is a property sourcing company?",
    a: "We find investment properties on your behalf, carry out due diligence, and present you with a packaged deal ready for purchase.",
  },
  {
    q: "How much does it cost to use your service?",
    a: "We charge a sourcing fee. This is discussed transparently at the outset.",
  },
  {
    q: "Are you regulated?",
    a: "We operate in full compliance with UK property sourcing regulations and are members of relevant industry bodies.",
  },
  {
    q: "What areas do you cover?",
    a: "We focus on East London, Stoke-on-Trent, and Essex — regions where we have deep, on-the-ground knowledge. Contact us to discuss your target area.",
  },
];

export function FAQ() {
  return (
    <section
      data-testid="faq-section"
      className="bg-[var(--navy)] text-[var(--ivory)] grain-overlay py-24 lg:py-32"
    >
      <div className="max-w-[920px] mx-auto px-6 lg:px-10">
        <div className="reveal text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[var(--gold)]" />
            <span className="text-[0.7rem] tracking-[0.32em] uppercase text-[var(--gold)]">
              Frequently Asked
            </span>
            <span className="h-px w-10 bg-[var(--gold)]" />
          </div>
          <h2 className="font-display text-4xl sm:text-5xl leading-[1.05]">
            Questions, <span className="italic text-[var(--gold)]">answered.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="reveal">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[rgba(201,168,76,0.18)]"
            >
              <AccordionTrigger
                className="faq-trigger hover:no-underline py-6 text-left font-display text-[1.2rem] sm:text-[1.35rem] text-[var(--ivory)] [&>svg]:hidden"
              >
                <span className="flex-1 pr-6">{f.q}</span>
                <span className="faq-icon shrink-0" aria-hidden="true" />
              </AccordionTrigger>
              <AccordionContent className="text-[var(--ivory)]/70 text-[0.98rem] leading-relaxed pb-6 pr-8">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
